function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { format, get, getQuery } from '@changba/funny';
import { get as getProp } from 'lodash-es';
import { props } from './props';
import { defineComponent } from '../utils/create';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "cb-lottery-record"
  }, [_c('div', {
    staticClass: "lottery-record"
  }, [_c('div', {
    staticClass: "lottery-record-header"
  }, _vm._l(_vm.columnGetter, function (column) {
    return _c('span', {
      key: column.prop,
      staticClass: "header-column",
      class: {
        'size-3': _vm.columnSize === 3,
        'size-4': _vm.columnSize === 4
      },
      attrs: {
        "data-prop": column.prop
      }
    }, [_vm._v("\n        " + _vm._s(column.label) + "\n      ")]);
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "lottery-record-container"
  }, [_vm.records.length > 0 ? _vm._l(_vm.records, function (item, idx) {
    return _c('div', {
      key: 'row' + idx,
      staticClass: "record-row"
    }, _vm._l(_vm.columnGetter, function (column) {
      return _c('span', {
        key: column.prop + '' + idx,
        staticClass: "record-column",
        class: {
          'size-3': _vm.columnSize === 3,
          'size-4': _vm.columnSize === 4
        },
        attrs: {
          "data-prop": column.prop
        }
      }, [_vm._v("\n            " + _vm._s(item[column.prop]) + "\n          ")]);
    }), 0);
  }) : _c('div', {
    staticClass: "lottery-record-empty"
  }, [_vm._v(_vm._s(_vm.emptyText))])], 2)]), _vm._v(" "), !_vm.noTips ? _c('div', {
    staticClass: "cb-lottery-record__tips"
  }, [_vm._v(_vm._s(_vm.tipsText))]) : _vm._e()]);
};
var staticRenderFns = [];
export default defineComponent({
  _scopeId: 'data-v-c6812ec2',
  render,
  name: 'CbLotteryRecord',
  props,
  data() {
    return {
      records: []
    };
  },
  computed: {
    columnGetter() {
      return Array.isArray(this.header) ? this.header : Object.entries(this.header).map(_ref => {
        var [prop, label] = _ref;
        return {
          prop,
          label
        };
      });
    },
    columnSize() {
      return Array.isArray(this.header) ? this.header.length : Object.keys(this.header).length;
    }
  },
  mounted() {
    if (this.immediate) {
      this.getData();
    }
  },
  methods: {
    getData() {
      var _this = this;
      return _asyncToGenerator(function* () {
        if (typeof _this.getServerData === 'function') {
          var resp = yield _this.getServerData();
          var respData = getProp(resp, _this.resultPath || 'data.list', []);
          _this.records = _this.formatData(respData);
        } else {
          _this.getLotteryRecord();
        }
      })();
    },
    getLotteryRecord() {
      var _this2 = this;
      return _asyncToGenerator(function* () {
        var isPreview = ['site-dev', 'site-prod'].includes(process.env.NODE_ENV) || getQuery('isMock');
        var url = isPreview ? "https://yapi.changbaops.com/mock/32/www/api/v1/reward/record" : window.BFF_HOST + "/api/v1/reward/record/" + _this2.actId;
        var resp = yield get({
          url,
          data: _this2.params,
          showLoading: _this2.showLoading,
          ignoreBaseURL: true
        });
        if (resp.code === 0) {
          var respData = getProp(resp, _this2.resultPath || 'data.list', []);
          _this2.records = _this2.formatData(respData);
        } else {
          _this2.toast(resp.msg || _this2.fetchErrorMsg);
        }
      })();
    },
    formatData(respData) {
      if (respData === void 0) {
        respData = [];
      }
      if (typeof this.formatter === 'function') {
        return respData.map(v => {
          var formatted = this.formatter(v);
          return _extends({}, formatted, {
            createdAt: v.createdAt ? this.formatDatetime(v.createdAt) : ''
          });
        });
      }
      return respData.map(v => {
        return _extends({}, v, {
          createdAt: v.createdAt ? this.formatDatetime(v.createdAt) : ''
        });
      });
    },
    formatDatetime(datetime) {
      var t = datetime;
      if (typeof datetime === 'string') {
        t = new Date(datetime == null ? void 0 : datetime.replace(/-/g, '/'));
      }
      return format(t, this.dateFormat);
    },
    toast(msg) {
      if (typeof this.$toast === 'function') {
        this.$toast(msg);
      } else if (typeof this.$Toast === 'function') {
        this.$Toast(msg);
      } else {
        // eslint-disable-next-line no-alert
        alert(msg);
      }
    }
  }
});